import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { programClient } from '../client/programClient';


export const useProgramLink = (slug: string) => {
  const { data: { data }, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.resolveProgramLink, slug],
    queryFn: () => programClient.resolveProgramLink({ slug }),
    retry: false,
  });

  return {
    ...rest,
    program: data,
  };
};
